var app = {
  // Distance to upper page border to start minimized scroll nav
  startScrollNav: 120
};
